import { useQuery } from "@tanstack/react-query";
import { vehicles } from "@fm/api";
import { ApiClient } from "@fm/api/types";

export function useVehicle(
  apiClient: ApiClient,
  fleetId: string,
  vehicleId: string,
) {
  return useQuery({
    queryKey: ["vehicle", fleetId, vehicleId],
    queryFn: () => vehicles.get(apiClient, fleetId, vehicleId),
    enabled: Boolean(fleetId && vehicleId),
  });
}
